import messages from './messages';

export const featureItems = [
	{
		description: messages.feature1,
		isLimitedLabel: true,
		isUnlimitedLabel: true,
	},
	{
		description: messages.feature3,
		isLimitedLabel: true,
	},
	{
		description: messages.feature6,
		isLimitedCheck: true,
	},
	{
		description: messages.feature2,
	},
	{
		description: messages.feature4,
	},
	{
		description: messages.feature5,
	},
	{
		description: messages.feature7,
	},
	{
		description: messages.feature8,
	},
	{
		description: messages.feature9,
	},
];
